import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';

const CardHoldersChart = ({ currentQuarter }) => {
  const loadCardholdersChart = () => {
    const chart = new Chart({
      type: 'view',
      container: 'cardholders-chart',
      height: 200,
      autoFit: true,
      theme: 'dark',
    });

    chart.axis('x', {
      title: false,
      label: false,
      line: {
        style: {
          stroke: 'white',
        },
      },
      tickLine: false,
    });

    chart.axis('y', {
      title: false,
      label: false,
      line: {
        style: {
          stroke: 'white',
        },
      },
      tickLine: false,
    });

    chart
      .line()
      .data(currentQuarter)
      .encode('x', 'month')
      .encode('y', 'count')
      .encode('shape', 'smooth')
      .style('stroke', 'white')
      .style('lineWidth', 4)
      .style('lineJoin', 'round')
      .style('lineCap', 'round');

    chart.render();
  };

  useEffect(() => {
    loadCardholdersChart();
  }, [currentQuarter]);

  return (
    <div id="cardholders-chart" />
  )
};

export default CardHoldersChart;